<template lang="pug">
  .shop
    CMSPartial(mixin-key="partial-shop-all-maximizable-video")
    CMSPartial(:mixin-key="shopMixinKey")

    .container
      .row.xs-f-small.max-at-tweak
        .fixed-width-tweak-upper
          .xs-12.xs-pl-100m.xs-pr-100m.xs-pb-200m
            ExpertiseIncluded

</template>

<script>
  import CMSPartial from '@components/CMSPartial';
  import ExpertiseIncluded from '@components/ExpertiseIncluded';
  import trackEventMixin from '@mixins/trackEventMixin';

  export default {
    name: "Shop",

    components: {
      CMSPartial,
      ExpertiseIncluded,
    },

    mixins: [trackEventMixin],

    data() {
      return {
        shopMixinKey: 'partial-shop-all-b',
      };
    },
  };
</script>

<style scoped lang="stylus">
  .shop
    background-color color-white

</style>
